function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7974 20.2701C26.9358 21.1173 24.9133 21.5531 22.868 21.5479C14.9086 21.5391 8.45847 15.089 8.4497 7.1296C8.44417 5.08431 8.87964 3.0619 9.72647 1.2002L10.2734 0L9.07118 0.540935C3.55245 3.0335 0.00468276 8.52674 0.00269403 14.5822C-0.000102626 23.0944 6.89806 29.9972 15.4103 30C21.4679 29.9961 26.9625 26.4468 29.4567 20.9264L29.9976 19.7232L28.7974 20.2701ZM22.496 27.1452C15.5616 31.0597 6.7668 28.6116 2.8523 21.6772C-1.06221 14.7427 1.38598 5.94798 8.32044 2.03348C7.74408 3.67058 7.45155 5.39406 7.45534 7.1296C7.46522 15.6377 14.3599 22.5324 22.868 22.5423C24.6035 22.5461 26.327 22.2535 27.9641 21.6772C26.6733 23.9638 24.7826 25.8545 22.496 27.1452Z",
  fill: "black"
});

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.31dedb21.svg";
export { ForwardRef as ReactComponent };